import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
              encapsulation: ViewEncapsulation.None,
  
})
export class ReportsComponent implements OnInit {

  public ads: any[] = [];
    public pages  : any

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
            private toastr : ToastrService,
                public _translateService: TranslateService
  ) {} 

  public currentPage = 1; 
  public itemsPerPage = 10;
  public totalItems = 0;
  public messages: any = {};

  public tempData = [];

  @ViewChild(DatatableComponent) table: DatatableComponent;

  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;v

  ngOnInit(): void {
                 this.getTags();

  
     this.setDatatableMessages(); // set initial messages

    // listen for language change dynamically
    this._translateService.onLangChange.subscribe(() => {
      this.setDatatableMessages();
    });

  }

   private setDatatableMessages() {
    this.messages = {
      totalMessage: this._translateService.instant('MENU.DASHBOARD.total')
    };
  }

// getTags() {
//   this.apisService.contracts().subscribe({
//     next: (response: any) => {
//       this.pages = response.data || [];
//       this.totalItems = this.pages.length;
//       console.log("pages:", this.pages);
//     },
//     error: (error: any) => {
//       console.error(error);
//     },
//   });
// }
getTags() {
  this.apisService.reports().subscribe({
    next: (response: any) => {

      this.pages = response?.data || [];   // 🔥 ده الصح
      this.totalItems = this.pages.length;

      console.log('pages:', this.pages);

    },
    error: (error: any) => {
      console.error(error);
    }
  });
}

  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  

 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.ads = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }


     /*----------  deleting   ----------*/
 DeleteContracts(id:any){ 
  this.apisService.DeleteReports(id).subscribe({
    next: (response: any) => {
   this.toastr.success(
        this._translateService.instant('MENU.DASHBOARD.DELETED_SUCCESSFULLY')
      );       this.getTags();
    },
    error: (error: any) => {
      console.log(error);
   this.toastr.error(
        this._translateService.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
      );    }
  }
    
  )
 } 

 editProduct(productId: number) {
  this.router.navigate(['/edit-reports', productId]);
}

confirmDelete(id: any) {
  Swal.fire({
    title: this._translateService.instant('MENU.DASHBOARD.CONFIRM_DELETE_TITLE'),
    text: this._translateService.instant('MENU.DASHBOARD.CONFIRM_DELETE_TEXT'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this._translateService.instant('MENU.DASHBOARD.YES_DELETE'),
    cancelButtonText: this._translateService.instant('MENU.DASHBOARD.CANCEL')
  }).then((result) => {
    if (result.isConfirmed) {
      this.DeleteContracts(id);
    }
  });
}


getContractRatio(row: any): number {
  const installment = row?.installments?.[0];

  if (!installment) {
    return 0;
  }

  const amount = Number(installment.amount || 0);
  const max = Number(installment.amount_max || 0);

  if (!max || max === 0) {
    return 0;
  }

  return +((amount / max) * 100).toFixed(1);
}




}
